import React, { useState, useEffect } from 'react';
import ReviewDashboard from './ReviewDashboard';
import { Review } from '../../types/Review';
import { reviewService } from '../../services/reviewService';

function ReviewsPage() {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadReviews();
  }, []);

  const loadReviews = async () => {
    try {
      setLoading(true);
      const data = await reviewService.getReviews();
      // Ensure data is always an array
      const reviewsArray = Array.isArray(data) ? data : [];
      setReviews(reviewsArray);
    } catch (err) {
      setError('Failed to load reviews');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddReview = async (reviewData: any) => {
    try {
      await reviewService.addReview(reviewData);
      await loadReviews();
    } catch (err) {
      console.error('Failed to add review:', err);
    }
  };

  return (
    <ReviewDashboard 
      reviews={reviews}
      loading={loading}
      error={error}
      onAddReview={handleAddReview}
      onRefresh={loadReviews}
    />
  );
}

export default ReviewsPage;